const _ = require('lodash');

const DEFAULT_ATC_SELECTOR = 'form[action="/cart/add"] [type=submit]';
const defaultSettings = {
  settings: {
    apply_to: "none",
    installment_months: 2,
    installment_first_pay: 50,
    widget_texts: {
      option_full: 'Full payment',
      option_installment: 'Installment payment',
      installment_tip: 'interest-free payments every 30 days',
      initial_payment: 'Initial payment',
    },
    selector_atc: {position: "before", selector: DEFAULT_ATC_SELECTOR},
    selector_widget: {position: "before", selector: DEFAULT_ATC_SELECTOR}
  },
  target_collections: [],
  target_products: [],
};

/* eslint func-names: 0 */
export class Settings {

  appName;

  /**
   * @param {string} appName
   * @constructor
   */
  constructor(appName) {
    this.appName = appName;
  }

  /**
   *
   */
  init() {
    const isSettingsSet = (
      typeof (Spurit) !== 'undefined'
      && typeof (Spurit[this.appName]) !== 'undefined'
      && typeof (Spurit[this.appName].settings) !== 'undefined'
    );
    let settings = defaultSettings;
    if (isSettingsSet) {
      settings = _.defaultsDeep(Spurit[this.appName].settings, settings);
    }
    for (let key in settings) {
      this[key] = settings[key];
    }
  }
}